import { merge } from 'lodash';
import { setMemberPreferences as setMemberPreferencesEndpoint } from 'admin/resources';
import { MEMBER_PREFERENCES_UPDATE } from 'admin/constants/actions';
import { AdminReducerState } from 'admin/reducers';

export type SetMemberPreferences = {
	memberId?: string;
	preferences: Partial<MemberPreferences>;
};

export function setMemberPreferences(props: SetMemberPreferences) {
	return async (dispatch, getState: () => AdminReducerState) => {
		const id = props.memberId || getState().user.id;
		const preferences = merge({}, getState().user.preferences, props.preferences);

		dispatch({ type: MEMBER_PREFERENCES_UPDATE.UPDATE, payload: { memberId: id, preferences } });

		try {
			await setMemberPreferencesEndpoint.params({ memberId: id }).send({ preferences });
			dispatch({ type: MEMBER_PREFERENCES_UPDATE.SUCCESS, payload: preferences });
		} catch (error) {
			dispatch({ type: MEMBER_PREFERENCES_UPDATE.FAIL, payload: error });
		}
	};
}
